import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { Constants } from '../shared/constants';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { NotificationService } from '../shared/services/notifications.service';
@Component({
  selector: 'app-resource-upload',
  templateUrl: './resource-upload.component.html',
  styleUrls: ['./resource-upload.component.scss']
,  standalone: false
})
export class ResourceUploadComponent implements OnInit, OnDestroy {
  constants: Constants = new Constants();
  selectedDocumentType: string;
  fileSize: string = '';
  error: string = "";
  uploadedFiles: File[] = [];
  tags: string[] = [];
  uploadedFileSize: number = 0;
  displayUploadedSize: string = '';
  canUpload: boolean = false;
  progressBarMode: ProgressBarMode = ProgressBarModes.indeterminate;
  percentage: number = 0;
  timeTaken: string = '';
  startTime: Date | null;
  isFileMissing: boolean = false;
  isDocTypeMissing: boolean = false;
  documentTypes:string[];
  constructor(private baseHttpService: BaseHttpService, private notification: NotificationService) { }

  ngOnDestroy(){
    
  }
  ngOnInit(): void {
   this.getResourceDocumentTypes();
  }

getResourceDocumentTypes(){

    this.baseHttpService.get(`${this.constants.getResourceDocumentTypesUrl}`)
      .toPromise().then((result: any) => {
        this.documentTypes = result;
      }).catch((error: any) => {
        this.notification.showError("There is an issue in fetching document types, Please try again.", "Error");
      });
}


  onFileSelected(event: any): void {
    this.reset();
    const allSelfiles = event.target.files;
    if (allSelfiles != null && allSelfiles.length > 0) {
      [...allSelfiles].forEach((file: any) => {
          this.uploadedFiles.push(file);
          this.fileSize = this.getReadableSize(file.size);
        
      });
    }
  }

  getTimeTaken(): string {
    if (!this.startTime) return '';
    let seconds = (new Date().getTime() - this.startTime.getTime()) / 1000;
    if (seconds < 60) {
      return seconds + ' seconds';
    } else if (seconds / 60 < 60) {
      return (seconds / 60).toFixed(2) + ' minutes';
    } else if (seconds / 60 / 60 < 24) {
      return (seconds / 60 / 60).toFixed(2) + ' hours';
    } else if (seconds / 60 / 60 / 24 < 30) {
      return (seconds / 60 / 60 / 24).toFixed(2) + ' days';
    }
    return 'too long'
  }
  getReadableSize(fSize: number): string {
    let size = (fSize / 1024);
    let fileSize = '';
    if (size < 1024) {
      fileSize = size.toFixed(2) + ' KB';
    } else if (size / 1024 < 1024) {
      fileSize = (size / 1024).toFixed(2) + ' MB';
    } else if (size / 1024 / 1024 < 1024) {
      fileSize = (size / 1024 / 1024).toFixed(2) + ' GB';
    }
    return fileSize;
  }

  async uploadFile(): Promise<void> {
    this.tags = [];
    this.startTime = new Date();
    if(!this.selectedDocumentType || this.selectedDocumentType.trim() === '') {
      this.isDocTypeMissing = true;
    }
    if(this.uploadedFiles.length === 0) {
      this.isFileMissing = true;
    }

    if (this.isDocTypeMissing || this.isFileMissing) {
      return;
    }
    this.canUpload = true;

    if (this.uploadedFiles.length > 0) {
      let file = this.uploadedFiles[0];
      if(file.size > 1024*1024*1024){//1 GB
        this.notification.showError("File size should be less than 1 GB.", "Validation Error");
        return;
      }
      const chunkSize = 6291456; //1024 * 1024 * 6; //6MB
      const totalChunks = Math.ceil(file.size / chunkSize);

      let initiateResult = await this.initiateMultipartUpload(file.name);

      let tasks = [];


      let fileKey = initiateResult.fileKey;
      let resourceId = initiateResult.resourceId;
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);
        //await this.uploadChunk(chunk, i, uploadId, totalChunks - i == 1)
        tasks.push(() => this.uploadChunk(chunk, i, initiateResult.uploadId, totalChunks - i == 1, fileKey));
      }
      let taskBatches = this.getTaskBatches(tasks);
      for (let i = 0; i < taskBatches.length; i++) {
        await Promise.all(taskBatches[i].map((task: any) => task()));
      }
      this.completeMultipartUpload(initiateResult.uploadId, fileKey, resourceId);
      this.timeTaken = this.getTimeTaken();
    }
    else {
      this.notification.showError("Please select a valid file for upload.", "Validation Error");
    }
  }


  getTaskBatches(tasks: any[]): any {
    let taskBatches = [];
    let batchSize = 4;
    // Split the tasks into batches
    for (let i = 0; i < tasks.length; i += batchSize) {
      taskBatches.push(tasks.slice(i, i + batchSize));
    }
    return taskBatches;
  }


  async initiateMultipartUpload(fileName: string): Promise<any> {
    return this.baseHttpService.post(`${this.constants.initiateMultipartUploadUrl}`,{
      documentType: this.selectedDocumentType,
      fileName: fileName,
    })
      .toPromise().then((result: any) => {
        return result;
      }).catch((error: any) => {
        this.notification.showError("There is an issue in file upload, Please try again.", "Error");
      });
  }

  async uploadChunk(chunk: Blob, chunkNumber: number, uploadId: string, isLastChunk: boolean,fileKey: string): Promise<void> {
    const formData = new FormData();
    formData.append('file', chunk, this.uploadedFiles[0].name);
    formData.append('chunkIndex', chunkNumber.toString());
    formData.append('uploadId', uploadId);
    formData.append('fileKey', fileKey);
    formData.append('isLastChunk', isLastChunk.toString());
    return this.baseHttpService.post(`${this.constants.uploadMultipart}/${this.selectedDocumentType}`, formData)
      .toPromise().then((result: any) => {
        this.uploadedFileSize += chunk.size;
        this.displayUploadedSize = this.getReadableSize(this.uploadedFileSize);
        this.progressBarMode = ProgressBarModes.determinate;
        this.percentage = Math.round((this.uploadedFileSize / this.uploadedFiles[0].size) * 100);
        this.timeTaken = this.getTimeTaken();
        this.tags.push(result.tag);
      }).catch((error: any) => {
        this.notification.showError("There is an issue in file upload, Please try again.", "Error");
      });
  }

  async completeMultipartUpload(uploadId: string, fileKey: string, resourceId: string): Promise<void> {
    let data={
      resourceId: resourceId,
      uploadId: uploadId,
      fileKey: fileKey,
      tags: this.tags
    }
    return this.baseHttpService.post(`${this.constants.completemultipartUploadUrl}`, data)
      .toPromise().then((result: any) => {
        this.fileSize = '';
        this.tags = [];
        this.notification.showSuccess("File Uploaded Successfully", "Success");
      }).catch((error: any) => {
        this.notification.showError("There is an issue in file upload, Please try again.", "Error");
      });
  }

  reset(): void {
    this.uploadedFiles = [];
    this.fileSize = '';
    this.tags = [];
    this.uploadedFileSize = 0;
    this.displayUploadedSize = ''
    this.progressBarMode = ProgressBarModes.indeterminate
    this.percentage = 0
    this.canUpload = false;
    this.timeTaken = '';
    this.startTime = null
    this.isFileMissing = false;
    this.isDocTypeMissing = false;
  }
}

export class ProgressBarModes {
  public static determinate: ProgressBarMode = 'determinate';
  public static indeterminate: ProgressBarMode = 'indeterminate';
}
